import { DatePicker } from '@/components/ui/date-picker';
import {
	FormField,
	FormItem,
	FormLabel,
	FormMessage,
} from '@/components/ui/form';
import { addDays } from 'date-fns';
import type {
	Control,
	UseFormGetValues,
	UseFormSetValue,
} from 'react-hook-form';
import type { BulkFormValues } from '../zod/bulk-form-schema';

interface DateRangeFieldsProps {
	setValue: UseFormSetValue<BulkFormValues>;
	getValues: UseFormGetValues<BulkFormValues>;
	control: Control<BulkFormValues>;
}

export function DateRangeFields({
	setValue,
	getValues,
	control,
}: DateRangeFieldsProps) {
	return (
		<div className='tw-grid tw-grid-cols-2 tw-gap-4'>
			<FormField
				control={control}
				name='startDate'
				render={({ field }) => (
					<FormItem>
						<FormLabel>Start Date</FormLabel>
						<DatePicker
							date={field.value}
							onSelect={(date) => {
								field.onChange(date);
								// Update end date if the current end date is before the new start date
								if (date) {
									const currentEndDate = getValues('endDate');
									if (currentEndDate && currentEndDate < date) {
										setValue('endDate', addDays(date, 1), {
											shouldValidate: true,
										});
									}
								}
							}}
							className='tw-w-full'
							displayFormat='MM/dd/yyyy'
						/>
						<FormMessage />
					</FormItem>
				)}
			/>

			<FormField
				control={control}
				name='endDate'
				render={({ field }) => (
					<FormItem>
						<FormLabel>End Date</FormLabel>
						<DatePicker
							date={field.value}
							onSelect={(date) => {
								field.onChange(date);
								// Update start date if the current start date is after the new end date
								if (date) {
									const currentStartDate = getValues('startDate');
									if (currentStartDate && currentStartDate > date) {
										setValue('startDate', addDays(date, -1), {
											shouldValidate: true,
										});
									}
								}
							}}
							className='tw-w-full'
							displayFormat='MM/dd/yyyy'
						/>
						<FormMessage />
					</FormItem>
				)}
			/>
		</div>
	);
}
